import {
  GET_CHECKPOINT_DEFINITION_REQUEST,
  GET_CHECKPOINT_DEFINITION_ERROR,
  GET_CHECKPOINT_DEFINITION_SUCCESS,
  CREATE_CHECKPOINT_DEFINITION_REQUEST,
  CREATE_CHECKPOINT_DEFINITION_ERROR,
  CREATE_CHECKPOINT_DEFINITION_SUCCESS,
  UPDATE_CHECKPOINT_DEFINITION_REQUEST,
  UPDATE_CHECKPOINT_DEFINITION_ERROR,
  UPDATE_CHECKPOINT_DEFINITION_SUCCESS,
  SET_DATA_IS_OBJECT
} from "../../actions/types";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {

    case GET_CHECKPOINT_DEFINITION_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: undefined
      };

    case GET_CHECKPOINT_DEFINITION_SUCCESS:
      return {
        ...state,
        checkpointDefinitions: action.payload,
        isFetching: false,
        error: undefined
      };

    case GET_CHECKPOINT_DEFINITION_ERROR:
      return {
        checkpointDefinitions: {},
        isFetching: false,
        error: `${action.error}`
      };


    case CREATE_CHECKPOINT_DEFINITION_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: undefined
      };

    case CREATE_CHECKPOINT_DEFINITION_SUCCESS:
      return {
        ...state,
        checkpointDefinitions: [...state.checkpointDefinitions, action.payload],
        isFetching: false,
        error: undefined
      };

    case CREATE_CHECKPOINT_DEFINITION_ERROR:
      return {
        ...state,
        isFetching: false,
        error: `${action.error}`
      };


    case SET_DATA_IS_OBJECT:
      return {
        ...state,
        dataIsObject: action.isObject
      };

    case UPDATE_CHECKPOINT_DEFINITION_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: undefined
      };

    case UPDATE_CHECKPOINT_DEFINITION_SUCCESS:
      let newState = {
        ...state,
        checkpointDefinitions: state.checkpointDefinitions.map(item => {
          if (item.ID === action.payload.ID) {
            return action.payload;
          }
          return item;
        }),
        isFetching: false,
        error: undefined
      }
      return { ...newState };

    case UPDATE_CHECKPOINT_DEFINITION_ERROR:
      return {
        ...state,
        error: `${action.error}`,
        isFetching: false,
      };

    default:
      return state;
  }
};
